import { isEmpty, get } from 'lodash'
import { mapActions, mapMutations } from 'vuex'
import doLoad from './methodDoLoad'
import { warning } from '@/utils/alert'
import bus from '@/utils/eventBus'

const apiN1 = get(process.env, 'API_NODE_URL')

export default {
  /**
   * Checando a geolocalozação atual.
   * @param {*} addressId
   */
  checkLatitudeLongitude (addressId) {
    if (addressId === null) {
      return
    }
    this.$http.get('/v1/patient/settings/addresses/' + addressId)
      .then(({data}) => {
        if ((data.latitude === '' && data.longitude === '') || (data.latitude === null && data.longitude === null)) {
          warning('Não foi possível carregar a localização geográfica para este local.')
        }
      })
      .catch(({data}) => {
      })
  },
  doLoad,
  ...mapActions('app/patient/agendas', [
    'loadAgendas'
  ]),
  ...mapMutations('app/patient/agendas', [
    'setFilters',
    'setLoading',
    'setValuesSearchedBy'
  ]),
  /**
   * Apos seleção do profissional, retorna as especialidade.
   * @param {*} professional
   */
  onSelectedProfessional (professional) {
    if (isEmpty(professional)) {
      return
    }
    this.$http.get('/v1/search/professionals/speciality-by-id/?limit=false&pagination=false&professional_id=' + professional.id)
      .then(({data}) => {
        this.professionalSpecialityOptions = data
        this.hiddenOptions = true
      })
      .catch(({data}) => {
      })

    this.agenda.professional = {...professional}
  },
  /**
   * Selecionando os dados da especiallidade pelo id
   * @param {*} speciality
   */
  onSelectedSpeciality (speciality) {
    if (isEmpty(speciality)) {
      return
    }

    if (!isEmpty(speciality)) {
      if (speciality.id !== undefined) {
        this.$http.get('/v1/search/specialities/' + speciality.id)
          .then(({data}) => {
            this.agenda.speciality = {...data}
          })
          .catch(({data}) => {
          })

        return
      }
      this.$http.get('/v1/search/specialities/' + speciality)
        .then(({data}) => {
          this.agenda.speciality = {...data}
        })
        .catch(({data}) => {
        })
    }
  },
  /**
   * Selecionado o paciente.
   */
  onSelectedPatient (patient) {
    if (isEmpty(patient)) {
      return
    }
    this.agenda.patient = {...patient}
  },
  /**
   * Localizando  pelo id do profissional
   */
  doSearchByProfessional () {
    if (this.$v.agenda.professional.id.$touch()) {
      return
    }
    if (this.$v.agenda.professional.id.$error) {
      return
    }
    this.agenda.speciality = {
      id: null,
      name: null
    }
    this.doLoad()
  },
  /**
   * Filtro por professional e especialidade
   */
  doSearchByProfessionalSpeciality () {
    if (this.agenda.professional.id === null) {
      bus.$emit('dont-validation-professional', {show: false})
    }
    if (this.$v.agenda.professional.id.$touch()) {
      return
    }
    if (this.$v.agenda.professional.id.$error) {
      return
    }
    if (this.$v.agenda.speciality.id.$touch()) {
      return
    }
    if (this.$v.agenda.speciality.id.$error) {
      return
    }
    this.doLoad()
  },
  /**
   * Filtro por Especialidade
   */
  doSearchBySpeciality () {
    if (this.$v.agenda.speciality.id.$touch()) {
      return
    }
    if (this.$v.agenda.speciality.id.$error) {
      return
    }

    this.agenda.professional = {
      id: null,
      name: null
    }
    this.doLoad()
  },
  /**
   * Valores de longitude e latituda para filtro por geolocalização atual.
   * @param {*} latitude
   * @param {*} longitude
   */
  setLocationByGeoLocation (latitude, longitude) {
    this.agenda.location.latitude = latitude
    this.agenda.location.longitude = longitude
  },
  /**
   * Filtro da longitude e latitude por CEP, Endereço, Cidade
   * @param {*} latitude
   * @param {*} longitude
   */
  setLocationByGeoLocationAll (latitude, longitude) {
    this.agenda.location.id = 'all'
    this.agenda.location.latitude = latitude
    this.agenda.location.longitude = longitude
  },
  /**
   * Setando valores do endereço localizado.
   * @param {*} address
   */
  setAddress (address) {
    this.agenda.address = {...this.agenda.address, ...address}
  },
  /**
   * Priemro campo para focus
   * @param {*} component
   */
  focusFirstStatus (component = this) {
    if (component.status) {
      component.$el.focus()
      return true
    }

    let focused = false

    component.$children.some((childComponent) => {
      focused = this.focusFirstStatus(childComponent)
      return focused
    })

    return focused
  },
  getAllSepcialities () {
    const getSpeciality = {
      fieldId: 'id',
      fieldText: 'name',
      table: 'specialities',
      order: 'name',
      headers: {'Access-Control-Allow-Origin': '*'}
    }
    this.$apin1.post(apiN1 + '/components/select', getSpeciality)
      .then(({data}) => {
        this.specialityOptions = data
      })
      .catch(({data, meta}) => {
        console.log('error')
      })
  },
  validarStatusAgenda () {
    const getStatusAgenda = {
      crm: '12543',
      uf: 'PR',
      data: '2018-11-05',
      hora: '10:00'
    }
    this.$apin1.post(apiN1 + '/professional/api/schedule_status', getStatusAgenda)
      .then(({data}) => {
        console.log(data)
      })
      .catch(({data, meta}) => {
        console.log('error')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/methods.js